import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import courseProductReadAction from './courseProductRead.action.json' assert { type: 'json' }

const courseProductReadDefinition = defineReadAutoAction(courseProductReadAction, 'courseProduct')

export default courseProductReadDefinition
